import React from 'react';
import Logo from '../assets/img/logo.png';

export default () => <img src={Logo} alt='RISA' width={75} />;
